import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { track0781ReviewPageReached } from '../../shared/utils/tracking/form0781Tracking';

/**
 * Used as page ContentBeforeButtons so FormPage keeps the default SchemaForm + nav.
 * Renders nothing; fires DataDog RUM when the 0781 review step is shown.
 */
const Form0781ReviewPageTracking = ({ formData }) => {
  useEffect(() => {
    track0781ReviewPageReached({
      workflowChoice: formData?.mentalHealthWorkflowChoice,
    });
  }, [formData?.mentalHealthWorkflowChoice]);

  return null;
};

Form0781ReviewPageTracking.propTypes = {
  formData: PropTypes.object,
};

export default Form0781ReviewPageTracking;
